<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminBuddy' }" class="tx-11" style="color: #444">Buddy ажилтан</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">{{ pageTitle }}</li>
              </ol>
            </nav>
          </div>

          
          <div class="wd-100p">
            <card-buddy :userTaskId="$route.params.id" :buddyObj="{ rdy: true }" @on-user-info="fetchTitle"></card-buddy>  
          </div>

          <table class="tbl-buddy mg-t-20">
            <thead>
              <tr>
                <th>Овог, нэр</th>
                <th>Домайн</th>
                <th>Buddy-лсан нэгж</th>
                <th>Buddy-лсан огноо</th>
                <th>Buddy ажилтнаар ажилласан өдөр</th>
                <!-- <th>Туршилтын ажилтнаар ажилласан өдөр</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="buddies.length<=0">
                <td colspan="6">
                  <div class="alert alert-secondary mg-t-10" role="alert">
                    Мэдээлэл хоосон байна.
                  </div>
                </td>
              </tr>
              <tr v-else v-for="(b,bi) in buddies">
                <td>
                  <div class="d-flex mg-y-6">
                    <div class="mg-r-10">
                      <img :src="`${b.newbie.avator}`" class="wd-40 rounded-circle" />
                    </div>
                    <div>
                      <div>{{ getFullName(b.newbie) }}</div>
                      <div class="tx-color-03 tx-normal">
                        <template v-if="b.departParent!=undefined">{{b.departParent.shortName}} - </template>{{b.depart.shortName}} - {{ b.position }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ b.newbie.loginName }}</td>
                <td>{{ b.depart.name }}</td>
                <td>{{ b.dueStartDate | moment('YYYY.MM.DD') }} - {{ b.dueDate | moment('YYYY.MM.DD') }}</td>
                <td>
                  <div class="d-flex ht-40 justify-content-center align-items-center">
                    {{ b.newbieDays.toFixed(0) }} өдөр
                    <feather @click.stop="bdyUpdate(b)" role="button" type="edit-3" style="margin-left:auto; width: 24px; height: 24px"></feather>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    <b-modal v-model="updateTask.modal" hide-footer title="Хугацаа өөрчлөх">

      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Дуусгавар болох огноо</label>
        <DatePicker
          v-model="updateTask.dueDate"
          placeholder="Огноо сонгоно уу"
          type="date"
          style="width: 100%"
          :format="'yyyy-MM-dd'"
          :value-format="'yyyy-MM-dd'"
        ></DatePicker>
      </div>

      <div>
        <div @click="updateTaskDo()" class="btn btn-block btn-info">Хадгалах</div>
      </div>
      
      
      
      <div>
        
      </div>
    </b-modal>


    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, DatePicker } from "element-ui";

export default {
  components: {
    DatePicker, 
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      buddies: [],
      pageTitle: null,
      updateTask:{
        dueDate: null,
        id: null,
        modal: false,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    updateTaskDo(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
          api: { method: "POST", url: "task/SetTaskFieldValue" },
          data: { 
              id: this.updateTask.id,
              fieldName: "dueDate",
              value: this.updateTask.dueDate
          },
          store: this.$store,
      }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          // console.log('updateTaskDo',res, this.updateTask);
          if (res != false) {
            this.updateTask.modal= false;
            Notification.success({ message: "Амжилттай", duration: 5000 });
            this.init();
          }
      });
    },
    bdyUpdate(b){
      // console.log('bdyUpdate',b);
      this.updateTask.dueDate= b.dueDate;
      this.updateTask.id= b.id;
      this.updateTask.modal= true;
    },
    fetchTitle(e){
      if(e.fullName!=undefined && e.fullName!=''){
        this.pageTitle= e.fullName;
      }
      //console.log('fetchTitle', e);
    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
        rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      // let rv=null;
      return rv;
    },
    gotoW(n) {
      // console.log('n', n);
      switch(n.id){
        case 1: 
          window.open('https://golomtbank.com', '_blank');
          break;
        case 2: 
          this.$router.push({name: 'buddyCulture', params: { id: 0} })
          break;
        case 3: 
          this.$router.push({name: 'buddyVoucher', params: { id: 0} })
          break;
        case 4: 
          this.$router.push({name: 'buddyEvent', params: { id: 0} })
          break;
        case 5: 
          this.$router.push({name: 'buddyQuiz' })
          break;
        default: break;
      }
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/getNewbies" },
        data: {
          pager:{
            skip: 0,
            size: 100,
          },
          filter: {
            buddyId: this.$route.params.id
          }
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.buddies= res.data.list;
          // console.log('newbies', res.data);
        }
      });
    },
    
  },
};
</script>